import { Component, OnInit, OnChanges, ViewChild, ElementRef, Input, ViewEncapsulation } from '@angular/core';
import * as d3 from 'd3';
import { PyramidVO, SectionVO } from '../shared';

@Component({
  selector: 'app-pyramid-chart',
  templateUrl: './pyramid-chart.component.html',
  styleUrls: ['./pyramid-chart.component.css']
})
export class PyramidChartComponent implements OnInit {

  @ViewChild('pyramidchart') private chartContainer: ElementRef;
  @Input('externalData') externalData: PyramidVO;
  @Input() private data: Array<any>;
  private chart: any;
  reportTitle: string;
  width = 500;
  height = 500;
  color;

  constructor() { }

  ngOnInit() {
    this.createChart();
    if (this.data) {
      this.updateChart();
    }
  }

  ngOnChanges() {
    if (this.chart) {
      this.updateChart();
    }
  }

  createChart() {
    let element = this.chartContainer.nativeElement;

    this.reportTitle =  this.externalData.reportTitle;

    let radius = Math.min(this.width, this.height) / 2;

    let color = d3.scaleOrdinal()
	      .range(["#e0f0fa","#c0e1f5","#a1d3ef","#62b5e5","#2392d2","#3e83ae","rgb(165,218,366)"]);

    let sections = this.extractSections(this.externalData);
    

    this.chart = d3.select(element)
      .append("svg")
      .attr("width", this.width)
      .attr("height", this.height)
      .attr("preserveAspectRatio", "xMinYMin meet")
      .attr("viewBox", "0 0 500 500")
      .classed("svg-content", true)
      .append("g");

      let xScale = d3.scaleLinear()
                     .range([0, this.width]);

      let yScale = d3.scaleLinear()
                     .range([this.height, 0]);

  let line = d3.line()
                   .x( (d) => xScale(d.x))
                   .y( (d) => yScale(d.y));

  let pyramidgroup = this.chart.selectAll(".pyramid-group")
          .data(this.pyramid(sections))
          .enter().append("g")
          .attr("class", "pyramid-group");

        pyramidgroup.append("path")
                    .attr("d", function (d){  return line(d.coordinates);})
                    .style("fill", function(d) { return color(d.label); })
                    .attr("id",function(d) {  return d.label; })

        pyramidgroup.append("text")
          .attr("y", function(d, i) { 
            if(i === 0) {
              return yScale(d.coordinates[0].y) - 90;
            } else {  
                return yScale(d.coordinates[1].y) -10;
            }     
          })
          .attr("x", function(d, i) { 
             return 500/2;
          })
          .style("text-anchor", "middle")
          .text(function(d, i) { return d.label; });

          pyramidgroup.append("text")
          .attr("y", function(d, i) { 
            if(i === 0) {
              return yScale(d.coordinates[0].y) - 110;
            } else {  
                return yScale(d.coordinates[1].y) - 30;
            }     
          })
          .attr("x", function(d, i) { 
             return 500/2;
          })
          .style("text-anchor", "middle")
          .attr("font-weight", 400)
          .text(function(d, i) { return d.sectionTitle; });
  }

  pyramid(data) {
    let i = 0;
    let coordinates = this.coordinatesCalculation(data);
    /*data.sort(function(a,b) {
      return a.value - b.value;
    })*/
    var reorganizedData = data.reverse();

    reorganizedData.forEach(function(){
      reorganizedData[i].coordinates = coordinates[i].values;
      i++;
    })
    return reorganizedData;
  }

  coordinatesCalculation(data) {
      let size = [1,1];
      let w = size[0];
      let h = size[1];
      let coordinates= [];
      let ratio = (w/2)/h;
      let percentValues = this.percentageValues(data);
      let area_of_triangle = (w * h) / 2;

      for (var i=0,len=data.length;i<len; i++){
        let selectedPercentValues = this.d3Sum(i, percentValues),
            area_of_element = selectedPercentValues/100 * area_of_triangle,
            height1 = Math.sqrt(area_of_element/ratio),
            base = 2 * ratio * height1,
            xwidth = (w-base)/2;

        if (i===0){
            coordinates[i] = {"values":[{"x":w/2,"y":0},{"x":xwidth,"y":height1},{"x":base+xwidth,"y":height1}]};
        } else {
            coordinates[i] = {"values":[coordinates[i-1].values[1],{"x":xwidth,"y":height1},{"x":base+xwidth,"y":height1},coordinates[i-1].values[2]]};
        }
      }
      coordinates[0].values[1] = coordinates[coordinates.length-1].values[1];
      coordinates[0].values[2] = coordinates[coordinates.length-1].values[2];
      let first_data = coordinates.splice(0,1);
      coordinates = coordinates.reverse();
      coordinates.splice(0,0,first_data[0]);
      return coordinates;
  }

  d3Sum (i, percentValues) {
    return d3.sum(percentValues,function (d, j){
      if (j>=i) {
        return d;
      }
    });
  }

  percentageValues(data) {
      let values = data.map(function (d) {return (d as any).value });
      let sum = d3.sum(values, function (d){ return +d });
      let percentValues = data.map(function (d,i){
        //d.value = +values[i];
        //return values[i]/sum*100;
        if(i<= 2)
          return 18;
        else
          return 10;
      });
     // percentValues.sort(function(a,b){
     //   return b-a;
     // });
      return percentValues;
  }

  extractSections (data:PyramidVO):SectionVO[] {
    let sections = [];
    Object.keys(data).forEach((key) => {
      
      var value = data[key];
      var t =  typeof value;
      if (value instanceof Object) {
        var s = value as SectionVO;
        var sd = new SectionDrawVO();
        sd.sectionTitle = value.totalNumber + ' / ' + value.percent + '%';
        sd.label = value.sectionTitle;
        sd.value = value.totalNumber;
        sections.push(sd);
      }
    
    });
    return sections;
  }

  updateChart() {
    d3.select("svg").remove(); 
    this.createChart();
  }


}

export class SectionDrawVO {
  constructor(  
      public sectionTitle?:string,
      public label?:string,
      public value?:number,
  ) {
   
  }
}



// WEBPACK FOOTER //
// ./src/app/pyramid-chart/pyramid-chart.component.ts